import { useQuery } from '@tanstack/react-query';

import CSVService from '@/services/CSVService';

export const GET_SIGNED_URL_KEY = ['csv-signed-url'];

export function useGetSignedUrl() {
  const { data, isLoading, error, refetch } = useQuery({
    queryKey: GET_SIGNED_URL_KEY,
    queryFn: () => CSVService.getSignedUrl(),
    enabled: false,
  });

  return {
    signedUrl: data,
    isLoading,
    refetch,
    error,
  };
}
